export default __webpack_public_path__ + "static/media/s1-project.f32ede48.jpg";